/**
 * Checks whether a local filter module contains at least one non-empty
 * filter value. Handles both flat (`{ filterKey: [...] }`) and
 * channel-nested (`{ channel: { filterKey: [...] } }`) structures.
 */
export const isNonEmptyFilterModule = (value: unknown): boolean => {
  if (typeof value !== 'object' || value === null) return false;
  return Object.values(value).some(entry => {
    if (Array.isArray(entry) && entry.length > 0) return true;
    if (typeof entry === 'object' && entry !== null && !Array.isArray(entry)) {
      return Object.values(entry).some(nested => Array.isArray(nested) && nested.length > 0);
    }
    return false;
  });
};
